import React from 'react';
import type { FluentNovaMeControlProps } from './FluentNovaMeControlProps';
import { mecontrolPlaceHolderStyle } from './FluentNovaMeControlPlaceholder.scss';
import { Avatar } from '@fluentui/react-components';

/**
 * Placeholder rendered while the FluentNovaMeControl lazy bundle loads.
 * Keeps layout stable by preserving avatar footprint and (optionally) showing
 * any already fetched display name or photo from the launcher.
 */
export const FluentNovaMeControlPlaceholder: React.FC<FluentNovaMeControlProps> = props => {
    return (
        <div className={mecontrolPlaceHolderStyle} data-tid="fluent-me-control-placeholder-wrapper">
            <Avatar
                data-tid={'fluent-me-control-placeholder'}
                size={28}
                aria-label={props.initialDisplayName || ''}
                // Placeholder is non-interactive; click handler intentionally omitted.
                // If the image fails to load, we show generic avatar (no initials if not yet available)
                {...(props.initialPhotoUrl && {
                    name: props.initialDisplayName || undefined,
                    image: {
                        src: props.initialPhotoUrl || undefined,
                    },
                })}
            />
        </div>
    );
};
